import Regulations from "components/regulations/Regulations";


export default function Regulation() {
    return (
        <Regulations/>
    );
}
